import { ModelBase } from './model.base';


export class KeyValue extends ModelBase {
    code: string;
    name: string;

}
